import React from 'react'
import styled, { css } from 'styled-components'
import { FullAbsolute } from '../styles/Utils'
import { BodyCopy, H2 } from './Typography'
import media from 'css-in-js-media'
import Section from './Section'
import { Variables } from '../styles/Variables'

const StyledExperience = styled(Section)`
    position: relative;
    background-color: ${Variables.color.lightGrey};
    margin: 0;
`

const StatSection = styled.div<{ $layout: string }>`
    text-align: center;
    max-width: ${(props) => (props.$image ? '209px' : '338px')};
    position: relative;
    z-index: 10;

    ${media('<desktop')} {
        max-width: none;
        width: 100%;
        padding: 46px 0;
    }

    ${H2} {
        font-family: ${Variables.font.title};
        font-style: normal;
        font-weight: 400;
        font-size: 38px;
        line-height: 44px;
        margin-bottom: 10px;
        color: ${(props) => (props.$image ? Variables.color.white : Variables.color.pazola)};
        ${media('<desktop')} {
            font-size: 32px;
            line-height: 37px;
        }
    }

    ${BodyCopy} {
        line-height: 22px;
        font-weight: ${(props) => (props.$image ? '300' : 'normal')};
        font-size: ${(props) => (props.$image ? '18px' : '18px')};
        color: ${(props) => (props.$image ? Variables.color.white : Variables.color.pazola)};
    }
`

const Wrapper = styled.div`
    display: flex;
    padding: 0 30px;
    ${(props) =>
        props.$image &&
        css`
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
        `}
    z-index: 10;
    justify-content: space-around;
    ${media('>=desktop')} {
        padding: ${(props) => (props.$image ? '90px 0 75px 0' : '90px 0')};
    }
    ${media('<desktop')} {
        flex-direction: column;
    }
    :after {
        content: '';
        ${FullAbsolute}
        ${media('<desktop')} {
            min-height: 957px;
            top: auto;
        }
    }
`

const StyledTimeline = styled.div`
    ${media('<desktop')} {
        padding-top: 35px;
        padding-bottom: 35px;
    }
    ${H2} {
        font-weight: 300;
        font-size: 24px;
        line-height: 30px;
        margin-bottom: 20px;
        display: inline-block;
        padding: 0 18px;
        background: #efe9da;

        ${media('<desktop')} {
            padding: 3px 0 0;
            margin-bottom: 10px;
            font-size: 16px;
            line-height: 20px;
        }
    }

    ${BodyCopy} {
        max-width: 240px;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        margin: auto;

        ${media('<desktop')} {
            font-size: 16px;
            line-height: 20px;
        }
    }

    ${StatSection} {
        ${media('<desktop')} {
            padding: 18px 0;
        }

        &:nth-child(2) {
            ${BodyCopy} {
                max-width: 171px;
            }
        }
    }

    ${StatSection}:after {
        content: '';
        position: absolute;
        top: 15px;
        left: 50%;
        width: 30vw;
        height: 1px;
        background: #14323c;
        z-index: -1;

        ${media('<desktop')} {
            top: 87%;
            left: 50%;
            width: 1px;
            height: 35px;
        }
    }

    ${StatSection}:last-child:after {
        display: none;
    }
`

const Stats = ({ data }) => {
    return (
        <StyledExperience>
            {data.layout == 'timeline' ? (
                <StyledTimeline>
                    <Wrapper $image={data.desktopImage}>
                        {data.items.map((section, index) => {
                            return (
                                <StatSection key={index} $image={data.desktopImage}>
                                    <H2>{section.title}</H2>
                                    <BodyCopy
                                        dangerouslySetInnerHTML={{
                                            __html: section.subtitle,
                                        }}
                                    />
                                </StatSection>
                            )
                        })}
                    </Wrapper>
                </StyledTimeline>
            ) : (
                <Wrapper $image={data.desktopImage}>
                    {data.items.map((section, index) => {
                        const lastItem = data.items.length - 1 == index
                        return (
                            <StatSection $layout={lastItem ? null : data.layout} $image={data.desktopImage} key={index}>
                                <H2>{section.title}</H2>
                                <BodyCopy>{section.subtitle}</BodyCopy>
                            </StatSection>
                        )
                    })}
                </Wrapper>
            )}
        </StyledExperience>
    )
}

export default Stats
